import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelText as _vModelText, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71abbe46"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Delivery Options for an Order", -1))
const _hoisted_2 = { class: "row left" }
const _hoisted_3 = { class: "col-md-2" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "forApp"
}, " For App ", -1))
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "forApi"
}, " For Api ", -1))
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "printOnly"
}, " Production Type ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "-- not set --", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "beforeCutoff"
}, " Before Same Day Cutoff ", -1))
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "heightInches"
}, " Height inches ", -1))
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "widthInches"
}, " Width inches ", -1))
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "heightMM"
}, " Height mm ", -1))
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "widthMM"
}, " Width mm ", -1))
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "currencyId"
}, " User Currency ", -1))
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "mb-3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "shippingCountryId"
}, " Shipping Country ", -1))
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "shippingPostcode"
}, " Shipping Post Code ", -1))
const _hoisted_30 = { class: "mb-3" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "priceListId"
}, " Price list ", -1))
const _hoisted_32 = ["value"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3 separator" }, [
  /*#__PURE__*/_createElementVNode("hr"),
  /*#__PURE__*/_createElementVNode("div", null, "Promo Code"),
  /*#__PURE__*/_createElementVNode("div", null, "Free Shipping")
], -1))
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "userBranchId"
}, " User Branch ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "-- not set --", -1))
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "mb-3" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "promoCode"
}, " Promo Code ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3 separator" }, [
  /*#__PURE__*/_createElementVNode("hr"),
  /*#__PURE__*/_createElementVNode("div", null, "Subscription"),
  /*#__PURE__*/_createElementVNode("div", null, "Free Shipping")
], -1))
const _hoisted_41 = { class: "mb-3" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "userId"
}, " User Id ", -1))
const _hoisted_43 = { class: "mb-3" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-2",
  for: "orderTotalExcludingVAT"
}, " Order Total Ex VAT ", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3 separator" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1))
const _hoisted_46 = { class: "mb-3" }
const _hoisted_47 = { class: "col-md-10 main" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "results-grid" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Branch", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Delivery Method", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Dimension Inches", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Price", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Free Shipping", -1))
const _hoisted_55 = { class: "json" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            id: "forApp",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.forApp) = $event)),
            class: "form-check-input",
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, _ctx.model.forApp]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            id: "forApi",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.forApi) = $event)),
            class: "form-check-input",
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, _ctx.model.forApi]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("select", {
            id: "productionTypeId",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.productionType) = $event)),
            class: "form-select",
            "aria-label": "Select Production Type"
          }, [
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productionTypes, (o) => {
              return (_openBlock(), _createElementBlock("option", {
                key: o.Id,
                value: o.Id
              }, _toDisplayString(o.Name), 9, _hoisted_11))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.model.productionType]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            id: "beforeCutoff",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.beforeCutoffModel) = $event)),
            class: "form-check-input",
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, _ctx.model.beforeCutoffModel]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _withDirectives(_createElementVNode("input", {
            id: "heightInches",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.sizes[0].heightInches) = $event)),
            type: "number",
            class: "form-control",
            onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.model.heightMM = $event.target.value * 25.4))
          }, null, 544), [
            [
              _vModelText,
              _ctx.model.sizes[0].heightInches,
              void 0,
              { number: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _withDirectives(_createElementVNode("input", {
            id: "widthInches",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.sizes[0].widthInches) = $event)),
            type: "number",
            class: "form-control",
            onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.model.widthMM = $event.target.value * 25.4))
          }, null, 544), [
            [
              _vModelText,
              _ctx.model.sizes[0].widthInches,
              void 0,
              { number: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _withDirectives(_createElementVNode("input", {
            id: "heightMM",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.heightMM) = $event)),
            type: "number",
            class: "form-control",
            onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.model.sizes[0].heightInches = $event.target.value / 25.4))
          }, null, 544), [
            [
              _vModelText,
              _ctx.model.heightMM,
              void 0,
              { number: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _withDirectives(_createElementVNode("input", {
            id: "widthMM",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.widthMM) = $event)),
            type: "number",
            class: "form-control",
            onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.model.sizes[0].widthInches = $event.target.value / 25.4))
          }, null, 544), [
            [
              _vModelText,
              _ctx.model.widthMM,
              void 0,
              { number: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _withDirectives(_createElementVNode("select", {
            id: "currencyId",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.currencyId) = $event)),
            class: "form-select",
            "aria-label": "Select Currency"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencies, (currency, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: currency.Id
              }, _toDisplayString(currency.Code), 9, _hoisted_24))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.model.currencyId]
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _withDirectives(_createElementVNode("select", {
            id: "shippingCountryId",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.model.shippingCountryId) = $event)),
            class: "form-select",
            "aria-label": "Select Country"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: country.Id
              }, _toDisplayString(country.Name), 9, _hoisted_27))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.model.shippingCountryId]
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _withDirectives(_createElementVNode("input", {
            id: "shippingPostcode",
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.model.shippingPostcode) = $event)),
            type: "text",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.model.shippingPostcode]
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _withDirectives(_createElementVNode("select", {
            id: "priceListId",
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.model.priceListId) = $event)),
            class: "form-select",
            "aria-label": "Select Price List"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pricelists, (pl, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: pl.Id
              }, _toDisplayString(pl.Name), 9, _hoisted_32))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.model.priceListId]
          ])
        ]),
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _withDirectives(_createElementVNode("select", {
            id: "userBranchId",
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.model.userBranchId) = $event)),
            class: "form-select",
            "aria-label": "Select User Branch"
          }, [
            _hoisted_36,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branches, (o) => {
              return (_openBlock(), _createElementBlock("option", {
                key: o.Id,
                value: o.Id
              }, _toDisplayString(o.Name), 9, _hoisted_37))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.model.userBranchId]
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _withDirectives(_createElementVNode("input", {
            id: "promoCode",
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.model.promoCode) = $event)),
            type: "text",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.model.promoCode]
          ])
        ]),
        _hoisted_40,
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _withDirectives(_createElementVNode("input", {
            id: "userId",
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.model.userId) = $event)),
            type: "number",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.model.userId]
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _withDirectives(_createElementVNode("input", {
            id: "orderTotalExcludingVAT",
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.model.orderTotalExcludingVAT) = $event)),
            type: "number",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.model.orderTotalExcludingVAT]
          ])
        ]),
        _hoisted_45,
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
          }, " Test ")
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("pre", _hoisted_48, _toDisplayString(_ctx.error?.payload.message), 1))
          : (_ctx.results)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _hoisted_51,
                  _hoisted_52,
                  _hoisted_53,
                  _hoisted_54,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (r) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: r.Delivery.Id
                    }, [
                      _createElementVNode("div", null, _toDisplayString(r.DeliveryBranch.Id) + ": " + _toDisplayString(r.DeliveryBranch.Name), 1),
                      _createElementVNode("div", null, _toDisplayString(r.Delivery.Id) + ": " + _toDisplayString(r.Delivery.Abbreviation || "COL") + " " + _toDisplayString(r.Delivery.Name), 1),
                      _createElementVNode("div", null, _toDisplayString(r.DeliveryTwoDimension.Id) + ": " + _toDisplayString(r.DeliveryTwoDimension.MaxLongSideInches) + " x " + _toDisplayString(r.DeliveryTwoDimension.MaxShortSideInches), 1),
                      _createElementVNode("div", null, _toDisplayString(r.DeliveryTwoPrice.Id) + ": " + _toDisplayString(_ctx.currencies.find(o => o.Id === r.DeliveryTwoPrice.CurrencyId)
                  .Code) + " " + _toDisplayString(r.DeliveryTwoPrice.Price.toFixed(2)), 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, _toDisplayString(r.IsFreeShippingForPromoCode ? "PromoCode" : ""), 1),
                        _createElementVNode("div", null, _toDisplayString(r.IsFreeShippingForProSubscription ? "Subscription" : ""), 1)
                      ])
                    ], 64))
                  }), 128))
                ]),
                _createElementVNode("pre", _hoisted_55, _toDisplayString(_ctx.results), 1)
              ], 64))
            : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}